import React from 'react';
import { TextBlock } from '../TextBlock';

type ProfileAssetHeadingProps = { heading?: string };

const ProfileAssetHeading: React.FC<ProfileAssetHeadingProps> = ({ heading }) => {
  return heading ? (
    <TextBlock weight={'bold'} size={24}>
      {heading}
    </TextBlock>
  ) : null;
};

export default ProfileAssetHeading;
